<script>
    import {
        NormalInput,
        NormalSelect,
        NormalCell,
        NormalCheckBox,
        NormalRadio,
        NormalButton,
        NormalDateTimePicker,
        NormalCascader,
        NormalFileButton
    } from 'southcn-mobile-ui';
    import NormalQuestionItem from '@/components/widgets/NormalQuestionItem.vue';
    import NormalFeedback from '@/components/widgets/NormalFeedback.vue';

    const SCROLL_ARRAY = [ 'overflow', 'overflow-x', 'overflow-y' ];
    const DATE_TYPES = [ 'datetime', 'date', 'time' ];
    export default {
        name: 'NormalQuestionWrap',
        props: {
            data: {
                default () {
                    return [];
                },
                required: false
            },
            withArticle: {
                required: false,
            },
            preferences: {
                default () {
                    return [];
                },
                required: false
            },
            displayRules: {
                default () {
                    return [];
                },
                required: false
            },
            type: {
                required: false,
                default: 'question',
                type: String
            },
            status: {
                required: false,
                default: 'collecting',
                type: String
            }
        },
        data () {
            return {
                innerData: this.initData(),
                captchaUrl: undefined,
                commentData: this.initCommentData(),
                renderType: [ 'cascade-dropdown', 'radio', 'checkbox', 'dropdown', 'file', 'text', 'textarea', 'description', 'address', 'datetime', 'addressNew' ],
                fileList: [],
                captcha: '',
                subBtnDisabled: false,
                loading: false
            };
        },
        methods: {
            refreshCaptcha () {
                this.captchaUrl = this.$util.url('api', this.$config.apiUrl.captcha, {t: Math.random()});
            },
            initCommentData () {
                const data = [
                    {
                        title: '昵称',
                        type: 'text',
                        alias: 'name',
                        hint: '',
                        errorText: '',
                        result: {value: ''},
                        rules: {
                            required: true,
                            max_length: 20
                        }
                    },
                    {
                        title: '联系手机',
                        type: 'text',
                        alias: 'mobile',
                        hint: '',
                        errorText: '',
                        result: {value: ''},
                        rules: {
                            required: true,
                            validator: 'mobile'
                        }
                    },
                    {
                        title: '发表意见',
                        alias: 'content',
                        type: 'textarea',
                        errorText: '',
                        hint: '',
                        result: {value: ''},
                        rules: {
                            required: true
                        }
                    }
                ];
                return data.map(v => {
                    switch (v.type) {
                        case 'text':
                            this.createIptHint(v);
                            break;
                        case 'textarea':
                            this.createIptHint(v);
                            break;
                    }
                    return v;
                });
            },
            initData () {
                this.ruleMap = {};
                this.qaMap = {};
                this.optMap = {};
                this.afterInitdata = this.$util.deepCopy(this.data).map(v => {
                    v.result = {item_id: '', value: ''};
                    v.errorText = '';
                    if (this.preferences.display_rules) {
                        v.no = '';
                    }

                    if (v.other && v.type !== 'address') {
                        v.options.push({
                            value: v.other,
                            id: ':other:'
                        });
                        v.result.other = '';
                    }

                    switch (v.type) {
                        case 'checkbox':
                            v.result.value = [];
                            this.createCheckboxHint(v);
                            break;
                        case 'text':
                            this.createIptHint(v);
                            break;
                        case 'textarea':
                            this.createIptHint(v);
                            break;
                        case 'file':
                            v.fileList = [];
                            this.createFileHint(v);
                            break;
                        case 'address':
                            v.result.value = [];
                            v.options = this.initAddressOptions(this.$util.deepCopy(window.__ADDRESS__), v.rules.level);
                            break;
                        case 'addressNew':
                            v.result.value = [];
                            v.options = this.initAddressOptions(this.$util.deepCopy(window.__ADDRESS_NEW__), v.rules.level);
                            break;
                        case 'cascade-dropdown':
                            v.result.value = [];
                            v.options = this.initCascadeOptions(this.$util.deepCopy(v.options));
                            break;
                        case 'datetime':
                            v.dateType = DATE_TYPES[v.rules.level || 0];
                            break;
                    }
                    this.qaMap[v.id] = v;
                    return v;
                });

                if (this.displayRules) {
                    this.displayRules.forEach(v => {
                        const qaItem = this.qaMap[v.item_id];
                        this.ruleMap[v.item_id] = {
                            action: v.action.includes('end') ? 'end' : 'display',
                            list: v.action.includes('end') ? [ 'end' ] : v.action.replace('display:', '').split(',').map(v => {
                                this.qaMap[v].status = 'hide';
                                return this.qaMap[v];
                            }),
                            item_id: v.item_id
                        };
                        qaItem.action = this.ruleMap[v.item_id].action;
                        qaItem.triggerOptionsMap = {};
                        v.option_ids.forEach(opt => {
                            this.optMap[opt] = this.optMap[opt] || [];
                            if (qaItem.action === 'end') {
                                qaItem.triggerOptionsMap[opt] = 'end';
                                this.optMap[opt] = 'end';
                            } else if (qaItem.triggerOptionsMap[opt] !== 'end') {
                                qaItem.triggerOptionsMap[opt] = qaItem.triggerOptionsMap[opt] || [];
                                qaItem.triggerOptionsMap[opt] = qaItem.triggerOptionsMap[opt].concat(this.ruleMap[v.item_id].list || []);
                                this.optMap[opt] = this.optMap[opt].concat(this.ruleMap[v.item_id].list || []);
                            }
                        });
                    });
                }
                return this.afterInitdata.filter(v => v.status !== 'hide');
            },
            initCascadeOptions (options) {
                const obj = {};
                options.forEach(v => {
                    obj[v.id] = {
                        text: v.value,
                        value: v.id,
                        children: [],
                        parent_option_id: v.parent_option_id
                    };
                });
                const result = Object.values(obj);
                result.forEach(v => {
                    v.parent_option_id && obj[v.parent_option_id].children.push(v);
                });
                return result.filter(v => !v.parent_option_id);
            },
            createSelectOpt (item) {
                return item.options.map((v) => {
                    return {
                        text: v.value,
                        value: v.id
                    };
                });
            },
            changeNum (str) {
                const validator = this.$util.validate;
                if (!validator.isNumeric(str)) {
                    str = 0;
                } else {
                    str = Number(str);
                }
                return str;
            },
            createFileHint (data) {
                const rules = data.rules;
                const map = this.$config.uploadLimitMap;
                const maxSize = this.changeNum(rules.max_size);
                const maxQuantity = this.changeNum(rules.max_quantity);
                const validator = map[rules.mime];
                let str = '';
                if (maxQuantity > 0) {
                    str = '最多上传' + maxQuantity + '个文件';
                }
                if (maxSize > 0) {
                    str += (!str.length ? '' : '，');
                    str += '大小限制' + maxSize + 'Mb';
                }
                if (validator) {
                    str += (!str.length ? '' : '，');
                    str += '可上传' + validator;
                }
                const isEmpty = !this.$util.cleanText(data.hint).length;
                str = '<p>' + (isEmpty ? str : (str ? '(' + str + ')' : '')) + '</p>';
                data.hint = (data.hint || '') + (str);
            },
            createCheckboxHint (data) {
                const rules = data.rules;
                const map = this.$config.inputLimitMap;
                const maxLength = this.changeNum(rules.max_length);
                const minLength = this.changeNum(rules.min_length);
                let str = '';
                if (maxLength > 0 && minLength === 0) {
                    str = '仅最多选择' + maxLength + '字选项';
                } else if (minLength > 0 && maxLength === 0) {
                    str = '请最少' + minLength + '个选项';
                } else if (maxLength !== 0 && minLength !== 0) {
                    if (maxLength === minLength) {
                        str = '请选择' + maxLength + '个选项';
                    } else {
                        str = '请选择' + minLength + '~' + maxLength + '个选项';
                    }
                }
                const isEmpty = !this.$util.cleanText(data.hint).length;
                str = '<p>' + (isEmpty ? str : (str ? '(' + str + ')' : '')) + '</p>';
                data.hint = (data.hint || '') + (str);
                return data.hint;
            },
            createIptHint (data) {
                const rules = data.rules;
                const map = this.$config.inputLimitMap;
                const maxLength = this.changeNum(rules.max_length);
                const minLength = this.changeNum(rules.min_length);
                const validator = map[rules.validator];
                let str = '';
                if (maxLength > 0 && minLength === 0) {
                    str = '仅可输入' + maxLength + '个字以内';
                } else if (minLength > 0 && maxLength === 0) {
                    str = '请输入' + minLength + '个字以上';
                } else if (maxLength !== 0 && minLength !== 0) {
                    str = '仅可输入' + minLength + '~' + maxLength + '字';
                }
                if (validator) {
                    if (str.length === 0) {
                        str = '限制输入格式为：' + validator;
                    } else {
                        str += ', 限制输入格式为：' + validator;
                    }
                }
                const isEmpty = !this.$util.cleanText(data.hint).length;
                str = '<p>' + (isEmpty ? str : (str ? '(' + str + ')' : '')) + '</p>';
                data.hint = (data.hint || '') + (str);
                return data.hint;
            },
            changeFile ($e, item) {
                item.fileList = item.fileList || [];
                const rules = item.rules;
                const length = $e.length + item.fileList.length;
                if (rules.max_quantity && length > Number(rules.max_quantity)) {
                    this.$modal.alert({text: `上传文件数量不能超过${ rules.max_quantity }个`});
                    return;
                }
                const validator = this.$util.validate;
                const uploadMaps = this.$config.uploadLimitMap;
                for (let i = 0; i < $e.length; i++) {
                    const val = $e[i];
                    if (rules.mime !== '0') {
                        const text = uploadMaps[rules.mime];
                        if (text && !validator[rules.mime](val.name)) {
                            this.$modal.alert({text: `请上传正确的${ text }`});
                            return false;
                        }
                    }
                    const obj = {};
                    obj.file = val;
                    obj.name = val.name;
                    obj.type = val.type;
                    obj.size = val.size;
                    const sizeMb = obj.size / (1024 * 1024);
                    if (rules.max_size && sizeMb > rules.max_size) {
                        obj.progress = `出错`;
                        obj.errorText = `文件大小超过${ rules.max_size }Mb`;
                        obj.status = 'error';
                    } else {
                        obj.progress = '等待上传';
                        obj.status = '';
                    }
                    item.fileList.push(obj);
                }
                if (item.fileList.filter(v => v.status === 'error').length) {
                    return;
                }
                this.onStartUpload(item);
            },
            onDeleteFile (item, idx) {
                item.fileList.splice(idx, 1);
            },
            onStartUpload (item, idx = 0) {
                if (idx === item.fileList.length) {
                    return;
                }
                const curItem = item.fileList[idx];
                if (curItem.status === 'complete' || curItem.status === 'error') {
                    this.onStartUpload(item, ++idx);
                    return;
                }
                this.$api(this.$util.url('api', 'attachments/pre'), {
                    [`body[${ item.id }][0]`]: curItem.file,
                    questionnaire_id: window._CONFIG.QID,
                    item_id: item.id,
                    unit_id: window._CONFIG.SID
                }, {
                    onUploadProgress: (e) => {
                        item.fileList[idx].progress = Math.floor((e.loaded / e.total) * 100) + '%';
                        item.fileList.splice(idx, 1, item.fileList[idx]);
                    }
                }).then(d => {
                    item.fileList[idx].errorText = '上传完成';
                    item.fileList[idx].status = 'complete';
                    item.fileList[idx].value = `hashcrypt:${ d.id }`;
                }).catch((e) => {
                    item.fileList[idx].errorText = `${ e.errmessage }`;
                    item.fileList[idx].progress = '上传出错';
                    item.fileList[idx].status = 'error';
                    item.fileList[idx].value = 0;
                }).finally(() => {
                    this.onStartUpload(item, ++idx);
                });
            },
            checkRadioAndDropDown (item) {
                const {value} = item.result;
                const rules = item.rules;
                if (rules.required && this.$util.validate.isEmpty(value)) {
                    item.errorText = '至少选择一项';
                    return false;
                }
                item.errorText = '';
                item.result.item_id = item.id;
                return true;
            },
            checkCheckbox (item) {
                const {value} = item.result;
                const rules = item.rules;
                if (rules.required && !value.length) {
                    item.errorText = '该项必须填写';
                    return false;
                }
                if (value.length) {
                    if (rules.max_length && rules.max_length < value.length) {
                        item.errorText = `最多选择${ rules.max_length }项`;
                        return false;
                    }
                    if (rules.min_length && rules.min_length > value.length) {
                        item.errorText = `最少选择${ rules.min_length }项`;
                        return false;
                    }
                }
                item.errorText = '';
                item.result.item_id = item.id;
                return true;
            },
            checkRequired (item) {
                const {value} = item.result;
                const rules = item.rules;
                if (rules.required && ((value instanceof Array && !value.length) || !value)) {
                    item.errorText = '该题目为必答题';
                    return false;
                }
                item.result.item_id = item.id;
                return true;
            },
            onCheckboxChange ($e, item, opt) {
                if ($e) {
                    item.result.value.push(opt.id);
                } else {
                    let location = item.result.value.length;
                    item.result.value.forEach((item, index) => {
                        if (item === opt.id) {
                            location = index;
                        }
                    });
                    item.result.value.splice(location, 1);
                }
                this.handleDisplayRule(item);
            },
            checkTextAndArea (item) {
                const {rules, result} = item;
                const {value} = result;
                const validator = this.$util.validate;
                const inputMaps = this.$config.inputLimitMap;
                if (rules.required) {
                    if (value.length === 0) {
                        item.errorText = '请填写此题';
                        return false;
                    }
                }
                if (value.length > 0) {
                    if (rules.max_length && rules.max_length < value.length) {
                        item.errorText = `字数不能超过${ rules.max_length }个字`;
                        return false;
                    }
                    if (rules.min_length && rules.min_length > value.length) {
                        item.errorText = `字数不能少于${ rules.min_length }个字`;
                        return false;
                    }
                    if (rules.validator !== '0') {
                        const text = inputMaps[rules.validator];
                        if (text && !validator[rules.validator](value)) {
                            item.errorText = `请输入正确的${ text }格式`;
                            return false;
                        }
                    }
                }
                item.errorText = '';
                item.result.item_id = item.id;
                return true;
            },
            checkFile (item) {
                const value = item.fileList.map(v => {
                    if (v.status === 'complete') {
                        return v.value;
                    }
                    return undefined;
                }).filter(v => v);

                const {rules} = item;
                const validator = this.$util.validate;
                const uploadMaps = this.$config.uploadLimitMap;
                if (rules.required) {
                    if (value.length === 0) {
                        item.errorText = '至少上传一个文件';
                        return false;
                    }
                }
                if (value.length > 0) {
                    if (rules.max_quantity && rules.max_quantity < value.length) {
                        item.errorText = `上传文件数量超过${ rules.max_quantity }个`;
                        return false;
                    }
                    if (rules.max_quantity && rules.max_size < this.max_filesize) {
                        item.errorText = `上传文件大小超过${ rules.max_size }Mb`;
                        return false;
                    }
                    if (rules.mime !== '0') {
                        const text = uploadMaps[rules.mime];
                        for (let i = 0; i < item.fileList.length; i++) {
                            if (text && !validator[rules.mime](item.fileList[i].name)) {
                                item.errorText = `请上传正确的${ text }`;
                                return false;
                            }
                        }
                    }
                }
                item.errorText = '';
                item.result.value = value;
                item.result.item_id = item.id;
                return true;
            },
            getTips () {
                const preferences = this.preferences;
                const frequency = preferences.frequency;
                if (frequency === 'once') {
                    return '您已提交过此问卷，不能重复提交。';
                } else if (frequency === 'daily') {
                    return '您今日已提交过此问卷，请明日再来。';
                } else if (frequency === 'weekly') {
                    return '您这周已提交过此问卷，请下周再来。';
                }
            },
            onSubmitQa () {
                if (window._CONFIG.isGotoAuth) {
                    this.handleGotoLogin();
                    return;
                }
                if (this.loading) {
                    return;
                }
                if (this.type === 'comment_area') {
                    this.submitComment();
                } else {
                    this.submitQa();
                }
            },
            onViewResult () {
                window.location.href = window.getResultUrl();
            },
            checkCommentData () {
                let checked = true;
                const data = this.commentData;
                const result = {};
                for (let i = 0; i < data.length; i++) {
                    const v = data[i];
                    switch (v.type) {
                        case 'text':
                            checked = this.checkTextAndArea(v);
                            break;
                        case 'textarea':
                            checked = this.checkTextAndArea(v);
                            break;
                    }
                    if (!checked) {
                        v.errorText = v.errorText === '请填写此题' ? `请输入${ v.title }` : v.errorText;
                        this.$modal.alert({
                            text: v.errorText
                        });
                        return;
                    }
                    result[v.alias] = v.result.value;
                }
                if (this.captcha.length === 0) {
                    this.$modal.alert({
                        title: '提示',
                        text: `请输入验证码`
                    });
                    return;
                } else {
                    result.captcha = this.captcha;
                }
                return result;
            },
            submitComment () {
                const result = this.checkCommentData();
                if (!result) {
                    return;
                }
                this.loading = true;
                this.$loading.show();
                result.questionnaire_id = window._CONFIG.QID;
                result.unit_id = window._CONFIG.SID;

                this.fetchValidate(result, (v) => {
                    this.fetchComment(v);
                });

            },
            fetchComment (data) {
                this.$api(this.$util.url('api', 'comments'), data).then((d) => {
                    this.$modal.alert({
                        text: '提交成功',
                        okCallback: () => {
                            this.subBtnDisabled = true;
                            window.location.reload();
                        }
                    });
                }).catch(e => {
                    let text = e.errcode === 429 ? '回复频率过高，请稍后再试' : `评论提交失败：${ e.errmessage }`;
                    this.$modal.alert({
                        title: '抱歉',
                        text: text
                    });
                }).finally(() => {
                    this.loading = false;
                    this.$loading.hide();
                });
            },
            submitQa () {
                let checked = true;
                for (let i = 0; i < this.innerData.length; i++) {
                    const v = this.innerData[i];
                    switch (v.type) {
                        case 'checkbox':
                            checked = this.checkCheckbox(v);
                            break;
                        case 'radio':
                            checked = this.checkRadioAndDropDown(v);
                            break;
                        case 'dropdown':
                            checked = this.checkRadioAndDropDown(v);
                            break;
                        case 'cascade-dropdown':
                            checked = this.checkRadioAndDropDown(v);
                            break;
                        case 'text':
                            checked = this.checkTextAndArea(v);
                            break;
                        case 'textarea':
                            checked = this.checkTextAndArea(v);
                            break;
                        case 'file':
                            checked = this.checkFile(v);
                            break;
                        case 'address':
                            checked = this.checkRequired(v);
                            break;
                        case 'addressNew':
                            checked = this.checkRequired(v);
                            break;
                        case 'datetime':
                            checked = this.checkRequired(v);
                            break;
                    }
                    if (!checked) {
                        this.$modal.alert({
                            title: '提示',
                            text: `${ (this.preferences.display_rules && this.displayRules) ? `题目填写有误` : `第 ${ v.no } 题填写有误，` } 请检查后重新提交`
                        });
                        return;
                    }
                }
                const data = {
                    body: {},
                    questionnaire_id: window._CONFIG.QID,
                    unit_id: window._CONFIG.SID
                };
                if (this.preferences.captcha) {
                    if (this.captcha.length === 0) {
                        this.$modal.alert({
                            title: '提示',
                            text: `请输入验证码`
                        });
                        return;
                    } else {
                        data.captcha = this.captcha;
                    }
                }
                this.innerData.filter(v => v.result.item_id).forEach(v => {
                    const {item_id, value, other} = v.result;
                    data['body'][item_id] = value;
                    if (other) {
                        let val = (v.type.includes('address')) ? [ value.join('·'), `:other:${ other }` ] : `:other:${ other }`;

                        if (v.type === 'addressNew') {
                            val = [ this.getText4NewAddress(value), `:other:${ other }` ];
                        }

                        if (v.type === 'checkbox') {
                            val = [ ...(value).filter(v => v !== ':other:'), val ];
                        }
                        data['body'][item_id] = val;
                    } else if (v.type === 'address') {
                        data['body'][item_id] = [ value.join('·') ];
                    } else if (v.type === 'addressNew') {
                        data['body'][item_id] = [ this.getText4NewAddress(value)];
                    }
                    if (data['body'][item_id] instanceof Array && !data['body'][item_id].length) {
                        data['body'][item_id] = null;
                    }
                });

                this.loading = true;
                this.$loading.show();
                if (this.preferences.captcha) {
                    this.fetchValidate(data, (v) => {
                        this.fetchSubmit(v);
                    });
                } else {
                    this.fetchSubmit(data);
                }
            },
            getText4NewAddress (value) {
                let __ADDRESS_NEW__ = window.__ADDRESS_NEW__;
                const temp = value;
                let add = temp.shift();
                let resultAddress = [];
                while (add && (__ADDRESS_NEW__ && __ADDRESS_NEW__.length)) {
                    __ADDRESS_NEW__ = __ADDRESS_NEW__.find(v => Number(v.value) === Number(add));
                    if (__ADDRESS_NEW__) {
                        resultAddress.push(__ADDRESS_NEW__.text);
                        add = temp.shift();
                        __ADDRESS_NEW__ = __ADDRESS_NEW__.children;
                    }
                }
                return resultAddress.join('·');
            },
            fetchValidate (data, cb) {
                this.$api(this.$util.url('api', 'captcha'), {
                    captcha: data.captcha
                }).then(() => {
                    cb && cb(data);
                }).catch((e) => {
                    console.log(e);
                    this.loading = false;
                    this.$loading.hide();
                    this.refreshCaptcha();
                    this.$modal.alert({
                        title: '提示',
                        text: e.errmessage
                    });
                });
            },
            fetchSubmit (data) {
                this.$api(this.$util.url('api', 'answers'), data).then((d) => {
                    this.$modal.alert({
                        text: '提交成功',
                        okCallback: () => {
                            this.subBtnDisabled = true;
                            if (this.preferences.show_result_after_answered) {
                                this.onViewResult();
                            }
                        }
                    });
                }).catch(e => {
                    let text = `问卷提交失败：${ e.errmessage }`;
                    if (e.errcode === 429) {
                        text = this.getTips();
                    }
                    this.$modal.alert({
                        title: '抱歉',
                        text: text
                    });
                }).finally(() => {
                    this.refreshCaptcha();
                    this.loading = false;
                    this.$loading.hide();
                });
            },
            handleGotoLogin () {
                this.$modal.alert({
                    title: '提示',
                    text: '请先登录统一身份认证平台',
                    okCallback: () => {
                        window.open(window._CONFIG.sxauthURL);
                        // window.location.href = window._CONFIG.sxauthURL;
                    }
                });
                this.$bus.$emit('cancel:focus');
            },
            initAddressOptions (opts, maxLevel, level = 0, pid = 0) {

                opts.forEach((v) => {
                    v.level = level;
                    v.pid = pid;
                    if (level === Number(maxLevel)) {
                        v.children = [];
                    }
                    if (v.children && v.children.length) {
                        this.initAddressOptions(v.children, maxLevel, level + 1, v.id);
                    }
                });
                return opts;
            },
            iteratorChildren (data, result) {

                data.forEach(v => {
                    if (this.hasEnd || v.state === 'in') {
                        return;
                    }
                    v.state = 'in';
                    result.push(v);
                    let {value} = v.result;
                    if (!(value instanceof Array)) {
                        value = [ value ];
                    }

                    value.forEach(val => {
                        const array = this.optMap[val];
                        if (array === 'end') {
                            this.hasEnd = true;
                        }
                    });

                    value.forEach(val => {
                        if (this.hasEnd) {
                            return;
                        }
                        const array = this.optMap[val];
                        if (array) {
                            this.iteratorChildren(array, result);
                        }

                    });
                });

            },
            handleDisplayRule () {
                if (!this.preferences.display_rules || !this.displayRules || !this.displayRules.length) {
                    return;
                }

                const data = this.afterInitdata.filter(v => v.status !== 'hide');

                let result = [];
                this.hasEnd = false;

                // 还原标记元素
                const deleteMap = {};
                this.innerData.forEach(v => {
                    deleteMap[v.id] = v;
                    deleteMap[v.id].state = '';
                });

                // 递归处理-》 生成新的题目列表
                this.iteratorChildren(data, result);

                result.forEach(v => {
                    if (deleteMap[v.id]) {
                        deleteMap[v.id].state = 'keep';
                    }
                });
                // 去除已赋值
                this.innerData.forEach(v => {
                    v.result.value = v.state !== 'keep' ? '' : v.result.value;
                    v.state = '';
                    if (v.state === 'keep' && v.fileList) {
                        v.fileList = [];
                    }
                });

                this.innerData = result;

            },
            compPickerPosition () {
                const instance = this.componentIns;
                if (!instance) {
                    return;
                }
                const picker = instance.$el.querySelector('.normal-picker');
                const react = picker.getBoundingClientRect();
                const scrollTop = window.parent.document.scrollingElement.scrollTop;
                const screenHeight = window.parent.innerHeight;
                let $iframe = window.parent.document.querySelector(`#yjzj_iframe_${ window._CONFIG.question_data.id }`);
                let limit = $iframe.getBoundingClientRect().height - react.height;
                const result = screenHeight + scrollTop - this.$util.getElementTop($iframe) - react.height;
                if (!(limit > 0 && result > limit)) {
                    picker.style.top = `${ result }px`;
                    picker.style.bottom = `unset`;
                } else {
                    picker.style.top = `unset`;
                    picker.style.bottom = 0;
                }
            },
            getStyleComputedProperty (element, property) {
                const css = window.getComputedStyle(element, null);
                return css[property];
            },
            handleVisible ({visible, instance}) {
                if (!window._CONFIG.isInIframe) {
                    return;
                }
                if (!visible) {
                    // 还原
                    if (this.elMap && this.scrollMap) {
                        Object.keys(this.elMap).forEach(key => {
                            const element = this.elMap[key];
                            const scroll = this.scrollMap[key];
                            SCROLL_ARRAY.forEach(style => {
                                element.style[style] = scroll[style];
                            });
                        });
                    }
                    this.elMap = {};
                    this.scrollMap = {};
                    this.componentIns = null;
                    window.parent.removeEventListener('scroll', this.compPickerPosition);
                    return;
                }
                this.scrollMap = this.scrollMap || {};
                this.elMap = this.elMap || {};
                setTimeout(() => {
                    this.componentIns = instance;
                    this.compPickerPosition();
                    window.parent.addEventListener('scroll', this.compPickerPosition);
                    // 缓存旧值
                    this.elMap.body = window.parent.document.querySelector('body');
                    this.elMap.html = window.parent.document.querySelector('html');
                    SCROLL_ARRAY.forEach(style => {
                        Object.keys(this.elMap).forEach(key => {
                            this.scrollMap[key] = this.scrollMap[key] || {};
                            this.scrollMap[key][style] = this.getStyleComputedProperty(this.elMap[key], style);
                        });
                    });
                    // 重置
                    Object.values(this.elMap).forEach(el => {
                        el.style.overflow = 'hidden';
                    });
                });
            }
        },
        components: {
            NormalInput,
            NormalSelect,
            NormalCell,
            NormalCheckBox,
            NormalRadio,
            NormalButton,
            NormalFileButton,
            NormalDateTimePicker,
            NormalCascader,
            NormalQuestionItem,
            NormalFeedback
        },
        computed: {
            feedback () {
                return window._CONFIG.question_data.feedback;
            },
            feedbackAt () {
                return window._CONFIG.question_data.feedback_at;
            },
            compTitle () {
                const {title, type} = this.data[0];
                return this.type === 'article' ? (type === 'title' ? title : '') : (
                    this.type === 'comment_area' ? '评论区' : ''
                );
            },
            showResultBtn () {
                const {show_result_after_closed, show_result_before_answered} = this.preferences;
                if (this.status === 'paused') {
                    return true;
                }
                return (show_result_before_answered) || (this.status === 'finished' && show_result_after_closed);
            }
        },
        mounted () {
            setTimeout(() => {
                if (window._CONFIG.isGotoAuth) {
                    const allForms = document.querySelectorAll('input,select,textarea');
                    Array.from(allForms).forEach(el => {
                        el.addEventListener('click', () => {
                            this.handleGotoLogin();
                        });
                    });
                }
            });
            setTimeout(() => {
                this.$util.setIframeHeight();
            });
            this.$bus.$on('start:captcha', () => {
                this.refreshCaptcha();
            });
            if (this.status !== 'collecting') {
                this.subBtnDisabled = true;
            }
        }

    };
</script>
<template>
    <div class="question">
        <div class="question__title" v-show="compTitle">
            {{ compTitle }}
        </div>
        <div class="question__body" v-if="this.type !== 'comment_area'">
            <template v-for="item in innerData">
                <div :key="item.id">
                    <normal-question-item :item="item" v-if="renderType.includes(item.type)">
                        <template v-slot:default v-if="item.type === 'dropdown'">
                            <normal-cell :use-label="true"
                                         class="option"
                                         style="padding:0">
                                <normal-select v-model="item.result.value"
                                               @change="handleDisplayRule(item, $event)"
                                               :options="createSelectOpt(item)"
                                               placeholder="请选择"></normal-select>
                            </normal-cell>
                            <normal-cell :use-label="true"
                                         class="option"
                                         style="padding:0"
                                         v-if="item.other && item.result.value === ':other:'">
                                <normal-input v-model="item.result.other" placeholder="请输入"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'cascade-dropdown'">
                            <normal-cell :use-label="true"
                                         class="option" style="padding: 0 !important;">
                                <normal-cascader v-model="item.result.value"
                                                 :options="item.options"
                                                 @visible="handleVisible"
                                                 :border="false"
                                                 placeholder="请选择"/>
                            </normal-cell>
                            <normal-cell :use-label="true"
                                         class="option" style="padding:0"
                                         v-if="item.other && item.result.value.includes(':other:')">
                                <normal-input v-model="item.result.other"
                                              :placeholder="`请输入${item.other}`"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type.includes('address')">
                            <normal-cell :use-label="true"
                                         class="option" style="padding: 0 !important;">
                                <normal-cascader v-model="item.result.value"
                                                 :options="item.options"
                                                 @visible="handleVisible"
                                                 :border="false"
                                                 placeholder="请选择"/>
                            </normal-cell>
                            <normal-cell :use-label="true"
                                         class="option" style="padding:0"
                                         v-if="item.other">
                                <normal-input v-model="item.result.other"
                                              :placeholder="`请输入${item.other}`"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'datetime'">
                            <normal-cell :use-label="true" class="option" style="padding:0">
                                <normal-date-time-picker v-model="item.result.value"
                                                         @visible="handleVisible"
                                                         :border="false"
                                                         :type="item.dateType"
                                                         placeholder="请选择"/>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'radio'">
                            <normal-cell :use-label="true"
                                         class="option"
                                         v-for="(opt,key) in item.options" :key="key">
                                <template v-slot:header>
                                    <normal-radio v-model="item.result.value"
                                                  @check="handleDisplayRule(item, $event)"
                                                  :label="item.id"
                                                  :value="opt.id"/>
                                </template>
                                <template v-slot:default>
                                    <div v-html="opt.value"></div>
                                </template>
                            </normal-cell>
                            <normal-cell :use-label="true"
                                         class="option" style="padding:0"
                                         v-if="item.other && item.result.value === ':other:'">
                                <normal-input v-model="item.result.other" placeholder="请输入"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'checkbox'">
                            <normal-cell :use-label="true" class="option"
                                         style="padding-top: 0;padding-bottom: 0;align-items: center"
                                         v-for="opt in item.options" :key="opt.id">
                                <template v-slot:header>
                                    <normal-check-box @check="onCheckboxChange($event,item,opt)"/>
                                </template>
                                <template v-slot:default>
                                    <div v-html="opt.value"></div>
                                </template>
                            </normal-cell>
                            <normal-cell :use-label="true"
                                         class="option" style="padding:0"
                                         v-if="item.other && item.result.value.includes(':other:')">
                                <normal-input v-model="item.result.other" placeholder="请输入"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'text'">
                            <normal-cell :use-label="true" class="option" style="padding:0">
                                <normal-input v-model="item.result.value" placeholder="请输入"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'textarea'">
                            <normal-cell :use-label="true" class="option" style="padding:0">
                                <normal-input v-model="item.result.value" type="textarea"
                                              placeholder="请输入"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'file'">
                            <normal-cell class="file-button" :use-label="true" style="padding:0">
                                <normal-file-button :multiple="true"
                                                    :disabled="subBtnDisabled"
                                                    @change="changeFile($event, item)">
                                    <span style="font-size: 14px">&#xe64e; &nbsp; 选择文件</span>
                                </normal-file-button>
                            </normal-cell>
                            <div class="attachment-list"
                                 :class="file.status"
                                 :key="fkey"
                                 v-for="(file, fkey) in item.fileList">
                                <normal-cell>
                                    <template v-slot:header>
                                        &#xe646;
                                    </template>
                                    <template v-slot:default>
                                        <p v-if="file.status !== 'complete'">{{ file.name }}</p>
                                        <a class="download-link" v-else
                                           href="#">{{ file.name }}</a>
                                        <p class="error-text" v-show="file.errorText">{{ file.errorText }}</p>
                                    </template>
                                    <template v-slot:footer>
                                        <span class="progress">{{ file.progress }}</span>
                                        <span class="error" @click="onDeleteFile(item,fkey)">删除</span>
                                    </template>
                                </normal-cell>
                            </div>
                        </template>
                    </normal-question-item>
                </div>
            </template>
        </div>
        <div class="question__body" v-else>
            <template v-for="item in commentData">
                <div :key="item.title">
                    <normal-question-item :item="item">
                        <template v-slot:default v-if="item.type === 'text'">
                            <normal-cell :use-label="true" class="option" style="padding:0">
                                <normal-input v-model="item.result.value" placeholder="请输入"></normal-input>
                            </normal-cell>
                        </template>
                        <template v-slot:default v-else-if="item.type === 'textarea'">
                            <normal-cell :use-label="true" class="option" style="padding:0">
                                <normal-input v-model="item.result.value" type="textarea"
                                              placeholder="请输入"></normal-input>
                            </normal-cell>
                        </template>
                    </normal-question-item>
                </div>
            </template>
        </div>
        <div class="captcha-box"
             v-if="(preferences.captcha || this.type === 'comment_area') && status === 'collecting'">
            <normal-cell>
                <template v-slot:header>
                    验证码：
                </template>
                <template v-slot:default>
                    <normal-input v-model="captcha"/>
                </template>
                <template v-slot:footer
                          v-if="captchaUrl">
                    <img class="captcha-image" @click="refreshCaptcha" :src="captchaUrl" alt="验证码"/>
                </template>
            </normal-cell>
        </div>
        <div class="question__footer"
             :class="{inline:showResultBtn}">
            <normal-button theme="primary"
                           :disabled="subBtnDisabled"
                           @click.native="onSubmitQa">提交
            </normal-button>
            <normal-button v-show="showResultBtn" @click.native="onViewResult">查看结果</normal-button>
        </div>
        <normal-feedback v-if="!withArticle"
                         :feedback="feedback"
                         :feedbackAt="feedbackAt"/>

    </div>
</template>
<style lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .captcha-box {
        .normal-input {
            width: 85%;
            border-radius: 5px;
            border: 1px solid @otherGreyBgClr;
        }
    }

    .question__body {
        .error-text {
            line-height: 1;
            color: @dangerActiveBg;
            .px2rem(font-size, 26)
        }


    }
</style>
<style scoped lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .question {

        &__footer {
            .px2rem(padding-top, 70);


            &.inline {
                text-align: center;

                .normal-btn {
                    .px2rem(width, 300);
                    .px2rem(margin, 20);
                    display: inline-block;
                }
            }
        }

        &__title {
            color: @otherBigTitleClr;
            .px2rem(font-size, 36);
            font-weight: bold;
            .px2rem(margin-top, 90);
            .px2rem(margin-bottom, 90);
            .px2rem(padding-bottom, 30);
            border-bottom: 1px solid @otherGreyBgClr;
        }


        .captcha-box {
            .normal-cell {
                padding: 0;
                line-height: 1;
            }

            .normal-input {
                border: 1px solid @otherGreyBgClr;
            }
        }

        .captcha-image {
            .px2rem(width, 180);
            .px2rem(height, 90);

        }
    }
</style>
